import { AgGridReact } from "ag-grid-react";
import ModalBasic from "../../component/ModalBasic";

// const colDefs = [
//     {
//         field: "type",
//         headerName: "Type",
//         minWidth: window.innerWidth * 0.07,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "partyACName",
//         headerName: "Party Ac Name",
//         minWidth: window.innerWidth * 0.1,
//         flex: 0.5,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "p_Address",
//         headerName: "Party Address",
//         minWidth: window.innerWidth * 0.07,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
// ];

export const PartyAccountPopUp = (props) => {

    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[65%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="table w-full rounded-[10px] pb-[30px]">
                    <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                        <div className="table-inner">
                            <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">{props.modalName ? props.modalName : ""}</h1>
                        </div>
                        <AgGridReact
                            rowData={props.partyAccountList} // Pass row data
                            rowHeight={40}
                            columnDefs={props.colDefs} // Pass column definitions
                            pagination={true} // Enable pagination
                            paginationPageSize={15}
                            onCellClicked={props.handleSelectChange}
                        />
                    </div>
                </div>
                {/* <table>
                    <tr>
                        <td>

                        </td>
                    </tr>
                </table> */}
                {/* <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[5px] pb-[10px] border-b border-slate-200">
                        <div className="input-outer-grp col-span-2 flex gap-2.5">
                            <div className="input-grp w-[100%]">
                                <label>Receipt no</label>
                                <TextInput id="receiptNo" name="receiptNo" value={props.receiptDetails.receiptNo} handleChange={(event) => props.handleChange(event, "receiptNo")} />
                            </div>
                        </div>
                        <div className="input-grp w-[100%]">
                            <label>Payment date</label>
                            <TextInput type="date" id="paymentDate" name="paymentDate" value={props.receiptDetails.paymentDate} handleChange={(event) => props.handleChange(event, "paymentDate")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[5px] pb-[10px] border-b border-slate-200">
                        <div className="input-outer-grp col-span-2 flex gap-2.5">
                            <div className="input-grp w-[100%]">
                                <label>Select vendor</label>
                                <TextInput id="selectVendor" name="selectVendor" value={props.receiptDetails.selectVendor} handleChange={(event) => props.handleChange(event, "selectVendor")} />
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Ref. no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.receiptDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-2.5 mb-3">
                        <div className="input-grp">
                            <label>Payment mode</label>
                            <SingleSelectWithSearch
                                id="paymentMode"
                                name="paymentMode"
                                optionArray={props.paymentModeList ? props.paymentModeList : null}
                                value={props.receiptDetails.paymentMode}
                                handleChangeTest={(event) => props.handleSelectChange(event, "paymentMode")}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Select bank</label>
                            <SingleSelectWithSearch
                                id="selectBank"
                                name="selectBank"
                                optionArray={props.bankList ? props.bankList : null}
                                value={props.receiptDetails.selectBank}
                                handleChangeTest={(event) => props.handleSelectChange(event, "selectBank")}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Select series</label>
                            <SingleSelectWithSearch id="selectSeries" name="selectSeries" value={props.receiptDetails.selectSeries} handleChangeTest={(event) => props.handleSelectChange(event, "selectSeries")} />
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch id="chequeNo" name="chequeNo" value={props.receiptDetails.chequeNo} handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Cheque date</label>
                            <TextInput type="date" id="chequeDate" name="chequeDate" value={props.receiptDetails.chequeDate} handleChange={(event) => props.handleChange(event, "chequeDate")} />
                        </div>
                        <div className="input-grp">
                            <label>Outstanding balance</label>
                            <TextInput type="number" id="outStandingBalance" name="outStandingBalance" value={props.receiptDetails.outStandingBalance} handleChange={(event) => props.handleChange(event, "outStandingBalance")} />
                        </div>
                        <div className="input-grp">
                            <label>Pending balance</label>
                            <TextInput type="number" id="pendingBalance" name="pendingBalance" value={props.receiptDetails.pendingBalance} handleChange={(event) => props.handleChange(event, "pendingBalance")} />
                        </div>
                        <div className="input-grp">
                            <label>Paid amount</label>
                            <TextInput type="number" id="paidAmount" name="paidAmount" value={props.receiptDetails.paidAmount} handleChange={(event) => props.handleChange(event, "paidAmount")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">
                        <div className="input-grp">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.receiptDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns">Save</button>
                        <button className="delete-btn btns" onClick={() => props.closeModal}>Close</button>
                    </div>
                </div> */}
            </div>
        </ModalBasic>
    );
}